import { OptionType } from '@liveauctioneers/hammer-ui-core/select';

export const defaultPageSizeOptions = [24, 48, 72, 96, 120];

export const defaultPageSizeSelectOptions: OptionType[] = defaultPageSizeOptions.map((value) => ({
    label: value.toString(),
    value,
}));
